import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const main = document.getElementById('main-content');
    if (main) {
      main.focus({ preventScroll: true });
    }
    // Also update meta description for basic SEO per route when available
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      const map = {
        '/': "Harris County Historical Society - Preserving and sharing Harris County's heritage since 1923",
        '/about': 'Learn about our mission, history, leadership, and programs.',
        '/events': 'Explore upcoming programs and events.',
        '/media': 'Browse markers, publications, and videos.',
        '/support': 'Become a member or donate to support our mission.',
        '/contact': 'Get in touch with the Harris County Historical Society.'
      };
      const path = window.location.pathname;
      description.setAttribute('content', map[path] || description.getAttribute('content'));
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop; 